/**
 * Lesson MCQ content validator
 * Validates lesson MCQ data for required fields
 */

import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import type { LessonMCQData } from './schema';

export const lessonMCQValidator: ContentValidator<LessonMCQData> = {
    validate(data: LessonMCQData): ValidationResult {
        const errors: ValidationResult['errors'] = [];

        if (!data?.title?.trim()) {
            errors.push({ field: 'title', message: 'Title is required.' });
        }

        const items = data?.questionSet?.items ?? [];
        if (items.length === 0) {
            errors.push({ field: 'questionSet', message: 'At least one MCQ question is required.' });
        }

        return { isValid: errors.length === 0, errors };
    },
};
